import { Box } from '@factorialco/deprecated-design-system'
import { Folder } from '@factorialco/f0-react/icons/app'

import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

interface Props {
  categoryLabel: string
}

const CategorySettings = ({ categoryLabel }: Props) => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo icon={Folder} title={categoryLabel} />
    </Box>
  )
}

export default CategorySettings
